import type { ModalContentItem } from './types';

/**
 * // Class Obj: モーダルに現在表示している汎用コンテンツの状態を管理
 * // Note:
 * // - 現在の group / item index をたどれるように、表示中の ModalContentItem を保持します。
 * // - next-item / prev-item / next-group / prev-group の基準点になります。
 */
export class ModalContentState
{
  private mCurrentItem: ModalContentItem | null = null;

  /**
   * // Method: 現在表示中の item を更新する
   */
  public setCurrentItem(content_item: ModalContentItem): void
  {
    this.mCurrentItem = content_item;
  }

  /**
   * // Method: 現在表示中の item を取得する
   */
  public getCurrentItem(): ModalContentItem | null
  {
    return this.mCurrentItem;
  }

  /**
   * // Method: 現在表示中の group 名を取得する
   */
  public getCurrentGroupName(): string | null
  {
    return this.mCurrentItem?.group_name ?? null;
  }

  /**
   * // Method: 現在表示中の item index を取得する
   */
  public getCurrentItemIndex(): number | null
  {
    return this.mCurrentItem?.item_index ?? null;
  }

  /**
   * // Method: 現在表示中の item 状態を初期化する
   */
  public reset(): void
  {
    this.mCurrentItem = null;
  }
}
